import { render, staticRenderFns } from "./WatchmanReport.vue?vue&type=template&id=18169c60&"
import script from "./WatchmanReport.vue?vue&type=script&lang=js&"
export * from "./WatchmanReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports